import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "@/components/Layout";
import HomePage from "@/pages/HomePage";
import AboutPage from "@/pages/AboutPage";
import ServicesPage from "@/pages/ServicesPage";
import B2BTrainingPage from "@/pages/B2BTrainingPage";
import TVETPage from "@/pages/TVETPage";
import ProjectsPage from "@/pages/ProjectsPage";
import BlogPage from "@/pages/BlogPage";
import PartnershipsPage from "@/pages/PartnershipsPage";
import GalleryPage from "@/pages/GalleryPage";
import ContactPage from "@/pages/ContactPage";
import DonatePage from "@/pages/DonatePage";
import ProgramsPage from "@/pages/ProgramsPage";
import CareersPage from "@/pages/CareersPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<HomePage />} />
            <Route path="about" element={<AboutPage />} />
            <Route path="services" element={<ServicesPage />} />
            <Route path="b2b-training" element={<B2BTrainingPage />} />
            <Route path="tvet" element={<TVETPage />} />
            <Route path="programs" element={<ProgramsPage />} />
            <Route path="careers" element={<CareersPage />} />
            <Route path="projects" element={<ProjectsPage />} />
            <Route path="blog" element={<BlogPage />} />
            <Route path="partnerships" element={<PartnershipsPage />} />
            <Route path="gallery" element={<GalleryPage />} />
            <Route path="contact" element={<ContactPage />} />
            <Route path="donate" element={<DonatePage />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
